export default {
    computed: {
        xPerSelection () {
            return this.$store.getters["widgetData/getXPerSelection"];
        }
    },
    methods: {
        checkXPerSelection () {
            if (this.xPerSelection) {
                let selectStore = this.$store.getters["widgetData/getSelectByCode"](this.xPerSelection.code);
                if (selectStore) {
                    return;
                }
                let defaultValue = this.xPerSelection.values.find(item => item.default === 1);

                this.$store.commit("widgetData/addSelect", {
                    sensitive: this.xPerSelection.attentionText !== "",
                    silentMode: true,
                    code: this.xPerSelection.code,
                    title: `${this.xPerSelection.title.replace("Number of c", "C")}: ${defaultValue.title}`,
                    query: defaultValue.value
                });
            }
        }
    }
};
